<template>
  <page-header-wrapper>
    <div class="erp-list-page baidao-list-page delivery-line-page">
      <basic-option-table :item="item" />
    </div>
  </page-header-wrapper>
</template>

<script>
import BasicOptionTable from '@/views/system/basicSettings/BasicOptionTable'

export default {
  name: 'ErpDeliveryLine',
  components: { BasicOptionTable },
  data () {
    return {
      item: {
        name: '配送线路',
        type: 'erp_delivery_line',
        description: '维护客户档案「客商运营配送」中的配送线路。停用后，新建和编辑客户时不再提供该线路，已保存的客户不受影响。'
      }
    }
  }
}
</script>
